import React from 'react';
import Icon from '../../../components/AppIcon';

const EmptyState = () => {
  return (
    <div className="flex-1 flex items-center justify-center p-6 bg-background">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="MessageSquare" size={40} className="text-muted-foreground" />
        </div>
        <h3 className="font-heading font-semibold text-xl mb-2">
          Select a conversation
        </h3>
        <p className="text-muted-foreground text-sm">
          Choose a conversation from the list to start messaging about custom orders, specifications, and special requests.
        </p>
      </div>
    </div>
  );
};

export default EmptyState;